import { InputLabel, Select, SelectProps } from '@mui/material';
import React, { ReactElement } from 'react';

interface Props {
	selectLabel: string;
	testId: string;
	children: React.ReactNode;
}

function LabelledSelect<T>(props: React.PropsWithChildren<SelectProps<T> & Props>): ReactElement {
	const { required, selectLabel, testId, MenuProps, inputProps, children, ...selectProps } = props;

	return (
		<>
			<InputLabel required={required}>{selectLabel}</InputLabel>
			<Select
				{...selectProps}
				label={selectLabel}
				data-testid={testId}
				MenuProps={{
					disableScrollLock: true,
					...MenuProps,
				}}
				inputProps={{
					'aria-label': selectLabel,
					...inputProps,
				}}
			>
				{children}
			</Select>
		</>
	);
}

export default LabelledSelect;
